import { useNavigate } from 'react-router-dom';
import RetailerLayout from './RetailerLayout';
import { Card, CardContent } from '@/components/ui/card';
import { Store, MapPin, DollarSign, Bell, Shield, ChevronRight } from 'lucide-react';

const cards = [
  {
    key: 'store-info',
    icon: Store,
    title: 'Store Info',
    subtitle: 'Name, address, hours, logo & store image',
    accent: 'from-blue-500 to-indigo-600',
  },
  {
    key: 'pickup-delivery',
    icon: MapPin,
    title: 'Pickup–Delivery',
    subtitle: 'Consumer & driver instructions, prep time',
    accent: 'from-emerald-500 to-teal-600',
  },
  {
    key: 'payout',
    icon: DollarSign,
    title: 'Payout',
    subtitle: 'Stripe Connect, bank account, schedule & fees',
    accent: 'from-amber-500 to-orange-600',
  },
  {
    key: 'notifications',
    icon: Bell,
    title: 'Notifications',
    subtitle: 'Order alerts & email/SMS preferences',
    accent: 'from-purple-500 to-pink-600',
  },
  {
    key: 'security',
    icon: Shield,
    title: 'Security',
    subtitle: 'Change password, manage team members',
    accent: 'from-slate-700 to-slate-900',
  },
];

export default function RetailerSettingsHub({ user, onLogout }) {
  const navigate = useNavigate();
  return (
    <RetailerLayout user={user} onLogout={onLogout}>
      <div className="space-y-8 max-w-5xl mx-auto">
        <div className="bg-gradient-to-r from-slate-900 to-indigo-900 rounded-2xl p-8 text-white shadow-xl">
          <h1 className="text-4xl font-bold mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
            Settings
          </h1>
          <p className="text-indigo-100">Manage your store, payouts, and team</p>
        </div>

        <div className="grid md:grid-cols-2 gap-5">
          {cards.map(({ key, icon: Icon, title, subtitle, accent }) => (
            <Card
              key={key}
              data-testid={`settings-hub-${key}`}
              className="cursor-pointer border-0 shadow-md hover:shadow-xl transition-all duration-300 group overflow-hidden"
              onClick={() => navigate(`/retailer/settings/${key}`)}
            >
              <CardContent className="p-0">
                <div className="flex items-center">
                  <div className={`bg-gradient-to-br ${accent} p-6 text-white`}>
                    <Icon className="w-10 h-10" />
                  </div>
                  <div className="flex-1 p-5">
                    <div className="flex items-center justify-between">
                      <div>
                        <h3 className="text-xl font-semibold text-gray-900">{title}</h3>
                        <p className="text-sm text-gray-600 mt-1">{subtitle}</p>
                      </div>
                      <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-gray-700 group-hover:translate-x-1 transition-all" />
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </RetailerLayout>
  );
}
